import { Component } from '@angular/core';
import { StoreService } from 'avn/modules/services/store.service';

@Component({
  selector: 'app-maintenance-scroller',
  templateUrl: './maintenance-scroller.html',
  styleUrls: ['./maintenance-scroller.scss']
})
export class MaintenanceScrollerComponent {
  public constructor(public globalStore: StoreService) {}

  public get messages(): string[] {
    return this.globalStore.maintenanceConfig.banner.messages ?? [];
  }

  public get message_head(): string {
    return this.globalStore.maintenanceConfig.banner.message_head ?? 'Important notice:';
  }
}
